



















































import { CrudService } from '@/data/services/crud.service';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Volunteer } from '@/data/models/volunteer.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class RinnovaTesseraModal extends Vue{
	@Inject('CrudService') volunteerCrudService !: CrudService<Volunteer>;
	@Prop() volunteerid!: number;
	volunteer: Volunteer = new Volunteer();
	parent!: any;

	constructor() {
		super();
	}

	mounted() {
		this.loadVolunteer();
	}

	loadVolunteer() {
		this.volunteerCrudService.getEntity(Volunteer, 'volunteer', this.volunteerid).then(res => {
			this.volunteer = res;
		})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	submit() {
		this.volunteerCrudService.saveEntity(Volunteer, 'volunteer', this.volunteer).then(res => {
			this.volunteer = res;
			this.parent.close();
			this.$buefy.notification.open({
				message: this.$t('num-card-saved').toString(),
				type: 'is-success',
			});
		})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

}
